// components/ai/ahamoment/ActionsBox.jsx
import React from 'react';
import { FaTasks } from 'react-icons/fa';

const ActionsBox = ({ actions }) => {
  return (
    <div style={{
      backgroundColor: '#2C2F36',
      color: '#FFFFFF',
      borderRadius: '16px',
      padding: '1rem',
      marginBottom: '1rem',
      fontFamily: 'Nunito Sans',
      boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
    }}>
      <div style={{
        fontWeight: '700',
        marginBottom: '0.75rem',
        fontSize: '17px',
        color: '#FF7C24',
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
      }}>
        <FaTasks /> Key Actions
      </div>
      {actions.map((text, index) => (
        <div key={index} style={{ marginBottom: '0.5rem' }}>
          <span style={{ fontWeight: '600', color: '#FFB800' }}>Action {index + 1}:</span>{' '}
          <span>{text}</span>
        </div>
      ))}
    </div>
  );
};

export default ActionsBox;
